import React, { createContext, useContext } from "react"

export interface QuizActions {
  answerQuestion(submission?: Quiz.Api.AnswerQuestionReq["submission"], wasTimeout?: boolean): void
  cancelQuiz(): void
  startQuiz(): void
  startQuestionCountdown(): void
  continueQuiz(): void
  enterRanking(userToken: string): void
}

export interface IQuizContext {
  quiz?: Quiz.Api.Quiz
  busy: boolean
  actions: QuizActions
}

export const QuizContext = createContext<IQuizContext>({
  busy: false,
  actions: {
    answerQuestion: () => {},
    startQuiz: () => {},
    startQuestionCountdown: () => {},
    cancelQuiz: () => {},
    continueQuiz: () => {},
    enterRanking: () => {},
  }
})
QuizContext.displayName = "QuizContext"

export const useQuiz = () => useContext(QuizContext)

export const WithQuiz: React.FC<React.PropsWithChildren<{quiz?: Quiz.Api.Quiz, busy: boolean, actions: QuizActions}>> = ({quiz, actions, busy, children}) => {
  return (
    <QuizContext.Provider value={{quiz, busy, actions}}>
      {children}
    </QuizContext.Provider>
  )
}
